import React from "react";
import "./logs.css";
import axios from "axios";
import baseConfig from "../../../config/config";
import moment from "moment";
import parse from "html-react-parser";

const Logs = (props) => {
  const [logData, setLogData] = React.useState([]);
  const [loader, setLoader] = React.useState([]);
  const [selectedIndex, setSelectedIndex] = React.useState(null);
  const [selectedLogData, setSelectedLogData] = React.useState(null);
  const [modelArray, setModelArray] = React.useState([]);

  const logs = async () => {
    setLoader(true);
    try {
      let url =
        baseConfig.apiBaseUrl +
        "/request/logs?RecordID=" +
        props.data["RequestID"];


      const response = await axios.get(url, {
        headers: {
          "Content-Type": "application/json",
          serviceid: sessionStorage.getItem("userToken"),
        },
      });

      if (response.status === 200) {
        return {
          data: response.data,
        };
      }
    } catch (error) {
      setLogData([]);
      setLoader(false);
    }
  };

  const getInitials = (userName) => {
    return userName
      ?.split(" ")
      .map((word) => word.charAt(0))
      .slice(0, 2)
      .join("");
  };

  const handleLogSelect = (index) => {
    setSelectedIndex(index);
    setSelectedLogData(logData[index]);
  };

  const renderLogValue = (value, field, isOldValue = false) => {
    const style = {
      backgroundColor: isOldValue ? "#eaeaea" : "#dff6dd",
      position: "relative",
      borderRadius: "4px",
      padding: "2px 6px",
      minHeight: "18px",
      ...(value?.length > 30
        ? {
            whiteSpace: "pre-wrap",
            wordBreak: "break-word",
          }
        : {}),
      ...(isOldValue ? { textDecoration: "line-through" } : {}),
    };

    return <div style={style}>{getFormattedText(value)}</div>;
  };

  React.useEffect(() => {
    const fetchData = async () => {
      const response = await logs();
      if (response && response.data) {
        setLogData(response.data);
        setLoader(false);
      }
    };
    fetchData();
  }, []);
  const getFormattedText = (richtext) => {
    if (richtext) {
      return parse(richtext);
    }
    return richtext;
  };
  return (
    <>
      <div className="text" style={{ fontSize: "13.5px" }}>
        History
      </div>

      <hr className="divider" />

      {!loader && logData.length > 0 ? (
        <div className="history-container">
          <div className="left-section">
            <hr color="#eaeaea" style={{ margin: "0px" }} />
            {logData.map((item, index) => (
              <React.Fragment key={index}>
                <div
                  className={`history-item ${
                    selectedIndex === index ? "selected" : ""
                  }`}
                  onClick={() => {
                    handleLogSelect(index);
                  }}
                >
                  <div
                    className="avatar"
                    style={{
                      fontWeight: "lighter",
                      marginRight: "10px",
                      height: "36px",
                      width: "36px",
                    }}
                  >
                    {getInitials(item.TransactionBy)}
                  </div>
                  <div className="description">
                    {item.TransactionBy} {item.Operation}{" "}
                    {item.FieldName !== "ModelID"
                      ? item.FieldName
                      : "ModelName"}
                  </div>
                  <div className="date">
                    {moment(item.Date).format("MM/DD/YYYY")}
                  </div>
                </div>
                <hr color="#eaeaea" style={{ margin: "0px" }} />
              </React.Fragment>
            ))}
          </div>
          <div className="right-section">
            <div
              style={{
                display: "flex",
                alignItems: "center",
                fontFamily: "Segoe UI",
                fontSize: "14px",
                lineHeight: "20px",
                letterSpacing: "0px",
              }}
            >
              <div
                className="avatar"
                style={{
                  fontWeight: "lighter",
                  marginRight: "10px",
                  height: "36px",
                  width: "36px",
                }}
              >
                {getInitials(
                  selectedLogData
                    ? selectedLogData?.TransactionBy
                    : logData[0]?.TransactionBy
                )}
              </div>
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "flex-start",
                  width: "90%",
                }}
              >
                <div style={{ flex: 1 }}>
                  <div style={{ fontWeight: "700" }}>
                    {selectedLogData
                      ? selectedLogData?.TransactionBy
                      : logData[0]?.TransactionBy}
                  </div>
                  <div style={{ fontSize: "13px" }}>
                    {selectedLogData ? (
                      <>
                        {selectedLogData?.TransactionBy}{" "}
                        {selectedLogData?.Operation}{" "}
                      </>
                    ) : (
                      <>
                        {logData[0]?.TransactionBy} {logData[0]?.Operation}{" "}
                      </>
                    )}
                  </div>
                </div>
                <div style={{ textAlign: "right" }}>
                  <div style={{ fontSize: "11px" }}>
                    {selectedLogData
                      ? moment(selectedLogData?.Date).format("MM/DD/YYYY")
                      : moment(logData[0]?.Date).format("MM/DD/YYYY")}
                  </div>
                </div>
              </div>
            </div>
            <hr color="#eaeaea" />

            <div
              className="log-details"
              style={{ display: "flex", width: "100%" }}
            >
              {/* Field Name */}
              <div
                style={{
                  marginRight: "10px",
                  width: "20%",
                  fontWeight: "bold",
                }}
              >
                {selectedLogData
                  ? selectedLogData?.FieldName
                  : logData[0]?.FieldName}
              </div>

              {/* New Value */}
              <div
                style={{
                  flex: 1,
                  whiteSpace: "pre-wrap",
                  wordBreak: "break-word",
                }}
              >
                {renderLogValue(
                  selectedLogData
                    ? selectedLogData?.NewValue
                    : logData[0]?.NewValue,
                  selectedLogData
                    ? selectedLogData?.FieldName
                    : logData[0]?.FieldName
                )}
              </div>

              {/* Old Value - Only show for UPDATED operations */}
              {((selectedLogData && selectedLogData.Operation === "UPDATED") ||
                (!selectedLogData && logData[0]?.Operation === "UPDATED")) && (
                <div
                  style={{
                    flex: 1,
                    whiteSpace: "pre-wrap",
                    wordBreak: "break-word",
                    marginLeft: "10px",
                    textDecoration: "line-through",
                  }}
                >
                  {renderLogValue(
                    selectedLogData
                      ? selectedLogData?.OldValue
                      : logData[0]?.OldValue,
                    selectedLogData
                      ? selectedLogData?.FieldName
                      : logData[0]?.FieldName,
                    true
                  )}
                </div>
              )}
            </div>
          </div>
        </div>
      ) : (
        <>
          {!loader && (
            <div
              className="text"
              style={{
                fontSize: "13.5px",
                textAlign: "center",
                padding: "20px",
              }}
            >
              There have been no updates made to the selected Request. Therefore,
              no logs available for this entry.
            </div>
          )}
        </>
      )}

      {loader && (
        <div className="loader-container">
          <div className="loader"></div>
        </div>
      )}
    </>
  );
};

export default Logs;
